import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    imageContainer: ({ imageColor, bgImage }: any) => ({
      minHeight: '38vh',
      backgroundColor: imageColor,
      backgroundImage: `url(${bgImage})`,
      backgroundPosition: '55% 75%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      [breakpoints.up('lg')]: {
        marginTop: -1,
        minHeight: 'calc(100vh - 56px)',
        overflow: 'hidden',
        width: 750,
        minWidth: 750,
        maxWidth: 750,
      },
    }),
    logo: {
      marginTop: 18,
      marginLeft: 21,
      [breakpoints.up('lg')]: {
        marginTop: 0,
        marginLeft: 40,
      },
    },
    welcomeMessage: {
      textAlign: 'center',
      marginBottom: 30,
    },
    imageWrapper: {
      marginTop: -20,
      padding: '0 31px',
      textAlign: 'center',
      justifyContent: 'center',
      display: 'flex',
    },
    subtitle: {
      color: palette().white,
    },
  });
